export default __webpack_public_path__ + "static/media/193.c7c3b9f1.png";